import React, { SelectHTMLAttributes } from 'react';
import { CSVTableRowProps } from 'types';
import { Select } from './styles';

const ColumnTypeRow = ({ rowIndex, columnLabels, isEditMode, values, useFormReturn }: CSVTableRowProps) => {
  const { register, setValue } = useFormReturn;

  if (isEditMode) {
    return (
      <tr>
        <th>타입</th>
        <td>
          <TypeSelect
            {...register('allColumnType', {
              onChange: (event) => {
                const value = event.currentTarget.value;

                setValue(
                  'columnTypes',
                  values.map(() => value)
                );
              },
            })}
          />
        </td>
        {columnLabels.map((label, i) => (
          <td key={`col/${label}/row/${rowIndex}/edit`}>
            {values?.[i] !== undefined && <TypeSelect {...register(`columnTypes.${i}`)} />}
          </td>
        ))}
      </tr>
    );
  }

  return (
    <tr>
      <th>{rowIndex}</th>
      {columnLabels.map((label) => (
        <td key={`col/${label}/row/${rowIndex}`}></td>
      ))}
    </tr>
  );
};

export default ColumnTypeRow;

const TypeSelect = React.forwardRef(
  (props: SelectHTMLAttributes<HTMLSelectElement>, ref: React.ForwardedRef<HTMLSelectElement>) => {
    return (
      <Select ref={ref} {...props}>
        <option value="auto">Auto</option>
        <option value="number">Number</option>
        <option value="category">Category</option>
        <option value="text">Text</option>
      </Select>
    );
  }
);
